<template>
  <span class="select-more">
    <span class="more-btn" @click="handleClick"><sass-icon type="hi-gengduogongneng" style="font-size: 14px;"/></span>
    <a-modal v-model="visiable" :mask="false" width="720px" title="选择用户" :footer="null">
      <div class="header">
        <a-input-search v-model="searchValue" placeholder="用户名/手机号" style="width: 240px;" @search="onSearch" />
        <a-button class="reset-btn" @click="handleReset">重置</a-button>
      </div>
      <div class="body">
        <a-table
          class="table"
          size="middle"
          :customRow="customRow"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="false"
        >
          <span slot="account" slot-scope="text" class="link-text">{{ text }}</span>
          <span slot="oprations" class="link-text">选择</span>
        </a-table>
      </div>
      <div class="table-footer">
        <span>共{{ total }}条数据</span>
        <a-pagination
          size="small"
          :total="total"
          :current="pageNo"
          :pageSize="pageSize"
          :pageSizeOptions="pageSizeOptions"
          showSizeChanger
          showQuickJumper
          @change="handlePageChange"
          @showSizeChange="handleSizeChange"
        />
      </div>
    </a-modal>
  </span>
</template>
<script>
import CommonIcon from '@/components/common-icon'
export default {
  name: 'SelectMore',
  components: {
    CommonIcon
  },
  props: {
    pageNo: {
      type: Number,
      required: true
    },
    pageSize: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    totalPage: {
      type: Number,
      required: true
    },
    users: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      visiable: false,
      searchValue: '',
      count: 5,
      pageSizeOptions: ['10', '20', '50', '100', '200', '500', '1000'], // 每页条数
      customRow: record => {
        return {
          on: {
            click: () => {
              this.$emit('set-value', record.id)
              this.visiable = false
            }
          }
        }
      },
      columns: [
        // {
        //   title: '账号',
        //   dataIndex: 'id',
        //   key: 'id',
        //   scopedSlots: { customRender: 'account' }
        // },
        {
          title: '手机号码',
          dataIndex: 'mobile',
          key: 'mobile'
        },
        {
          title: '用户名称',
          dataIndex: 'userName',
          key: 'userName'
        },
        {
          title: '操作',
          key: 'oprations',
          scopedSlots: {
            customRender: 'oprations'
          }
        }
      ]
    }
  },
  computed: {
    dataSource() {
      return this.users.map(item => {
        item.key = item.id
        return item
      })
    }
  },
  methods: {
    handleClick() {
      this.visiable = true
    },
    handleReset() {
      this.searchValue = ''
      this.$emit('search', '')
    },
    onSearch(value) {
      this.$emit('search', value)
    },
    handlePageChange(value) {
      this.$emit('page-change', value, this.searchValue)
    },
    handleSizeChange(value, size) {
      this.$emit('size-change', size, this.searchValue)
    }
  }
}
</script>
<style lang="less" scoped>
@import '~ant-design-vue/lib/style/index';
.select-more {
  box-sizing: border-box;
  width: 26px;
  text-align: center;
  cursor: pointer;
}
.more-btn {
  display: inline-block;
  padding-right: 10px;
  width: 100%;
  height: 100%;
}
.header {
  display: flex;
  align-items: center;
  margin: 8px 0;
}
.body {
  overflow-y: auto;
  position: relative;
  height: 360px;
}
.footer {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
}
.link-text {
  color: @primary-color;
  cursor: pointer;
}
.table-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
  // position: absolute;
  // left: 0;
  // bottom: 0;
  // right: 0;
}
.reset-btn {
  margin-left: 16px;
  background: #fafafa;
}
</style>
